/**
 * Created by Darek on 2016-07-14.
 */
//$(".rating").rating();